//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { useProduct } from "~/composables";
import { Icon } from "@iconify/vue2";
import { ref, computed } from "@nuxtjs/composition-api";
import { useUser } from "~/modules/customer/composables/useUser";

export default {
  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Icon,
  },
  setup(props, { emit }) {
    const { isAuthenticated } = useUser();
    const { getProductPath } = useProduct();

    const calculateDiscountPercentage = (originalPrice, discountedPrice) => {
      if (originalPrice <= 0 || discountedPrice <= 0) {
        return false;
      }

      if (discountedPrice >= originalPrice) {
        return false;
      }

      const discount = originalPrice - discountedPrice;
      const discountPercentage = (discount / originalPrice) * 100;

      return discountPercentage.toFixed() + "%";
    };

    const mouseOverCard = ref(false);
    const retailDiscount = ref(false);
    const specialPrice = computed(() => {
      return calculateDiscountPercentage(
        props.product.price_range.maximum_price.regular_price.value,
        props.product.price_range.maximum_price.final_price.value
      );
    });

    const productImage = computed(() => {
      if (
        !mouseOverCard.value ||
        (props.product.media_gallery && props.product.media_gallery.length < 1)
      ) {
        return props.product.thumbnail.url;
      } else if (
        props.product.media_gallery &&
        props.product.media_gallery.length > 1
      ) {
        if (
          props.product.media_gallery[1].url !== props.product.thumbnail.url
        ) {
          return props.product.media_gallery[1].url;
        } else {
          return props.product.media_gallery[0].url;
        }
      } else {
        return props.product.thumbnail.url;
      }
    });
    let sendToCart = ref(false);
    const addItemAnimation = () => {
      sendToCart.value = true;
      emit("click:add-to-cart");
      setTimeout(() => {
        sendToCart.value = false;
      }, 1700);
    };
    return {
      getProductPath,
      mouseOverCard,
      productImage,
      retailDiscount,
      isAuthenticated,
      specialPrice,
      addItemAnimation,
      sendToCart,
    };
  },
};
